import { Button, Modal } from '@/shared/components';

interface ConfirmInclusionsDeletionModalProps {
    isOpen: boolean;
    inclusionCount: number;
    isLoading: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

export function ConfirmInclusionsDeletionModal({ isOpen, inclusionCount, isLoading, onCancel, onConfirm }: ConfirmInclusionsDeletionModalProps) {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onCancel}
            ariaLabelledBy="confirm-inclusions-deletion-heading"
            className="max-w-md p-6"
        >
            <div className="space-y-4">
                <h2 id="confirm-inclusions-deletion-heading" className="text-lg font-semibold">
                    Switch to total cost?
                </h2>
                <p className="text-sm text-mp-muted">
                    This will reset the price on {inclusionCount} existing inclusion {inclusionCount === 1 ? 'line' : 'lines'} to £0. The lines stay attached as descriptive items.
                </p>
                <div className="flex justify-end gap-2 pt-2">
                    <Button type="button" variant="outline" size="sm" onClick={onCancel} disabled={isLoading}>
                        Cancel
                    </Button>
                    <Button type="button" size="sm" variant="warning" onClick={onConfirm} disabled={isLoading}>
                        {isLoading ? 'Converting...' : 'Confirm'}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
